import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/soluciones/tecnologia-aprendizaje/face-id")({
  head: () => ({
    meta: [
      { title: "FaceID | Tecnología de Aprendizaje | Mine Class" },
      {
        name: "description",
        content:
          "FaceID: validación biométrica de identidad por reconocimiento facial en tiempo real para capacitaciones y evaluaciones remotas.",
      },
      { property: "og:title", content: "FaceID | Mine Class" },
      { property: "og:description", content: "Validación biométrica por reconocimiento facial en tiempo real para capacitaciones y evaluaciones remotas en minería." },
      { property: "og:url", content: "https://mine-class.com/soluciones/tecnologia-aprendizaje/face-id" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/soluciones/tecnologia-aprendizaje/face-id" }],
  }),
  component: FaceIDContent,
});

function FaceIDContent() {
  return (
    <article className="space-y-6 text-[var(--color-on-surface-variant)] text-base md:text-lg leading-relaxed">
      <div>
        <span className="text-[10px] uppercase tracking-widest font-bold text-[var(--color-brand-coral)]">
          Validación biométrica
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-[var(--color-brand-purple)] mt-1">FaceID</h2>
      </div>

      <p>
        Validación de identidad impulsada íntegramente por inteligencia artificial. FaceID garantiza que
        la persona que realiza una capacitación, evaluación o acreditación sea efectivamente quien dice
        ser. Mediante reconocimiento facial, verifica la identidad del participante en tiempo real y a lo
        largo de todo el proceso, aportando seguridad, trazabilidad y cumplimiento normativo.
      </p>
      <p>
        Su tecnología evita fraudes y suplantaciones, reduciendo de forma significativa los riesgos
        asociados a procesos remotos. Se integra de forma nativa con todos los productos del ecosistema
        MineClass y, vía API, con cualquier sistema externo.
      </p>

      <div className="flex flex-wrap gap-2 pt-2">
        {["Reconocimiento facial", "Tiempo real", "Anti-fraude", "API"].map((f) => (
          <span
            key={f}
            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[var(--color-brand-coral)]/10 text-[var(--color-brand-coral)] text-[11px] font-semibold"
          >
            <span className="material-symbols-outlined text-[13px]">check</span>
            {f}
          </span>
        ))}
      </div>

      <div className="pt-4">
        <Link
          to="/contacto"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-[var(--color-brand-coral)] text-white text-xs font-bold uppercase tracking-widest rounded-full hover:bg-[var(--color-brand-purple)] transition-colors"
        >
          Cotizar Solución
          <span className="material-symbols-outlined text-base">arrow_forward</span>
        </Link>
      </div>
    </article>
  );
}
